import { useState } from "react";
import {
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";

export default function ClosePackageTreatmentModal({
  patient,
  latestPackage,
   totalDueAmount,
  visits,
  onClose,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
const [error, setError] = useState("");

 const handleClosePackageTreatment = async () => {
  try {
    setError("");

    // 🔴 CHECK 1: Unpaid consultations
    const unpaidConsultations = visits?.filter(
      (v) =>
        v.consultation_payment_status === "UNPAID" &&
        !v.used_from_package
    );

    if (unpaidConsultations?.length > 0) {
      setError(
        `Cannot close. ${unpaidConsultations.length} unpaid consultation(s) pending.`
      );
      return;
    }

    // 🔴 CHECK 2: Package due amount
    if (totalDueAmount > 0) {
      setError(
        `Cannot close. Pending due balance: ₹ ${totalDueAmount}`
      );
      return;
    }

    setLoading(true);

    await addDoc(collection(db, "package_treatment_closures"), {
      patient_id: patient.id,
      vpjc_id: patient.vpjc_id,
      package_id: latestPackage?.id,
      status: "COMPLETED",
      type: "PACKAGE_TREATMENT",
      completed_at: serverTimestamp(),
    });

    onSuccess();
    onClose();
  } catch (err) {
    console.error("Error closing package treatment:", err);
    setError("Failed to close package treatment");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[320px] text-center shadow-lg">
        <h2 className="text-lg font-semibold mb-4 text-[#204080]">
          Close Treatment
        </h2>

        <p className="text-sm text-gray-600 mb-6">
          Are you sure you want to mark this as{" "}
          <span className="font-semibold text-red-500">
            Treatment Closed
          </span>
          ?
        </p>
    {error && (
  <p className="text-sm text-red-600 mb-3 font-medium">
    {error}
  </p>
)}
        <div className="flex justify-center gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-gray-300 text-sm"
          >
            Cancel
          </button>

          <button
            onClick={handleClosePackageTreatment}
            disabled={loading}
            className="px-4 py-2 rounded-lg bg-red-500 text-white text-sm"
          >
            {loading ? "Closing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}